var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container__detail_page" },
    [
      [
        _c("div", { staticClass: "ranking__detail__table affiliations" }, [
          _c("div", { staticClass: "visual-responsive" }, [
            _c(
              "ul",
              { staticClass: "v2-lazy-list" },
              _vm._l(_vm.data, function(item) {
                return _c(
                  "li",
                  { staticClass: "lazy-list-item" },
                  [
                    _c("p", [_vm._v(_vm._s(item.SelectProduct))]),
                    _c("p", { staticClass: "mb-0" }, [
                      _c("strong", [_vm._v("RUC")]),
                      _vm._v(" " + _vm._s(item.RUC))
                    ]),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(item.BusinessName))
                    ]),
                    _c("progress-line", { attrs: { value: item.Steps } })
                  ],
                  1
                )
              })
            )
          ])
        ]),
        _c("v-progress-circular", {
          staticClass: "ranking__table__loader",
          class: { active: _vm.loading },
          attrs: { width: 3, color: "primary", indeterminate: "" }
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40c38a53", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40c38a53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/affiliations-mobile-table.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-40c38a53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/affiliations-mobile-table.vue
// module chunks = 0 1